import React from 'react';
import { Field, FormSection } from 'redux-form';
import { genders, i18n, isNameValid } from '../../../utils';
import { default as Dropdown } from '../Dropdown';

interface IProps {
  rowWidth?: string;
  disable?: boolean;
  t(key: string, options?: any): string;
}



export class GenderDropdown extends React.Component<IProps> {

  private genderInput;
  public render() {
    const { rowWidth, disable } = this.props;
    const form = (
      <Field
        {...this.props}
        forwardRef
        name='gender'
        rowWidth={rowWidth}
        placeholder={i18n.t('formFields:gender')}
        valueKey='value'
        displayKey='display'
        defaultIndex={-1}
        options={genders}
        component={Dropdown}
        isSearchable={false}
        showLabel={true}
        validate={isNameValid}
        ref={(ref) => { this.genderInput = ref; }}
        disabled={disable}
        accessible={!disable}
      />
    );

    return (<FormSection>{form}</FormSection>);
  }
}
